// @flow

import React from 'react';
import i18n from 'app/common/lib/i18n';
import type { Pin as PinFlowType } from 'app/packages/pinterest-flow-types/pin';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { Box, Icon, Text } from 'gestalt';

type Props = {
  pin: PinFlowType,
  fullWidth: number,
  iconSize: number,
  inRemoveInlineGroup: boolean,
  linkWidth: number,
  showMoreInfoButton?: boolean,
  handleMoreInfoClick?: (e: SyntheticEvent<>) => void,
};

export const MoreInfoButtonStyles = {
  backgroundColor: 'transparent',
  border: 0,
  color: '#8e8e8e',
  fontSize: '12px',
  fontWeight: 'bold',
  height: '15px',
  letterSpacing: '-0.3px',
  MozOsxFontSmoothing: 'grayscale',
  outline: 'none',
  padding: 0,
  WebkitFontSmoothing: 'antialiased',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  width: '100px',
};

const ProductPinTag = ({
  pin,
  fullWidth,
  handleMoreInfoClick = () => {},
  iconSize,
  showMoreInfoButton = false,
  linkWidth,
  inRemoveInlineGroup,
}: Props) => {
  if (!Boolean(pin && pin.rich_summary && pin.rich_summary.site_name) && !showMoreInfoButton) {
    return null;
  }
  const siteName = pin.rich_summary && pin.rich_summary.site_name;
  return (
    <Box
      marginTop={1}
      display="flex"
      direction="row"
      alignItems="center"
      justifyContent="between"
      width={fullWidth}
    >
      <Icon
        icon="tag"
        accessibilityLabel={i18n._('Product Pin', 'Icon indicating this Pin is a product')}
        color="darkGray"
        size={iconSize}
        inline
      />
      {siteName && (
        <Box marginLeft={1} width={linkWidth} display="flex" flex="grow">
          <Text truncate size="xs">
            {interpolateNamedTemplate(
              i18n._('{{ siteName }}', 'site name for product pin site on pin landing page'),
              {
                siteName,
              },
            )}
          </Text>
        </Box>
      )}
      {showMoreInfoButton && (
        <Box marginLeft={1} marginTop={-2}>
          <button
            className={inRemoveInlineGroup ? 'PinLandingCloseup__similarPin__button' : ''}
            onClick={handleMoreInfoClick}
            style={inRemoveInlineGroup ? {} : MoreInfoButtonStyles}
          >
            <Text truncate size="xs" color="gray" bold>
              {'...'}
            </Text>
          </button>
        </Box>
      )}
    </Box>
  );
};

export default ProductPinTag;
